// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3SpsE","footer":"ModalCreateQualiphyProcedure_footer__222Od","additionData":"ModalCreateQualiphyProcedure_additionData__2UEkz"};